$(document).ready(function() { 

    //$('#result-overall-search-btn').click(function(e){
    $("form.form-search").submit(function(e) {
       e.preventDefault();

        $("#result-show").hide();
        $("label.error").remove();
        $('.error').removeClass('error');
        $('.response').hide().html("");

       var form = $(this).attr('id');

       Swal.fire({
            title: "Please Wait! ...",   
            text: "", 
            imageUrl: "/images/ajax-loader.gif",
            showCloseButton: false, 
            showCancelButton: false, 
            showConfirmButton: false
        });

       //var formData = form.serialize();
       var formData =  new FormData(this);

        $.ajaxSetup({
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });
        
        var formAction = $(this).attr('action');
        //alert(formAction);

        $.ajax({
            url: formAction,
            method: 'POST',
            data: formData,
            cache:false,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function(data){
                if(data.errors){
                    
                    //console.log(data);

                    /*$.each(data.errors, function(key, value){

                        $('.alert-danger').show();
                        $('.alert-danger').append('<p>'+value+'</p>');

                    });*/

                    var errorHtml = '<ul class="alert-danger sweet-alert-error">';
                    $.each(data.errors, function(key, value){
                       errorHtml += "<li>"+value+"</li>";
                    });
                    errorHtml += "</ul>";

                    $('.response').show().append(errorHtml);

                    /*$(this).find('input, textarea, select').each(function(){

                        var error = data.errors[$(this).attr("name")] ? data.errors[$(this).attr("name")] : null;

                    
                        if(error) {
                            if($(this).parent().hasClass("date")){
                                $(this).parent().addClass("error").after('<label class="error">' + error + '</label>');
                            }else{
                                $(this).addClass("error").after('<label class="error">' + error + '</label>');
                            }
                        }
                    });*/

                    //var errorText = $('.alert-danger').get();
                    //alert(errorHtml);
                    swal.fire({  
                        title: "Error! ...",   
                        html: errorHtml ,   
                        type: "error",   
                        confirmButtonText: "Close" 
                        }
                        ,function(isConfirm) {
                        
                        }
                    );
                }else{
                    $("#display-show").show().html(data.html);
                    window.loadDataTables();
                    $("#form-wrapper").hide();

                    $('html, body').animate({
                        scrollTop: $("#display-show").offset().top - 200
                    }, 600);

                    swal.close();
                }
            },
            error: function(e) {
                console.log(e);

                swal.fire({  
                    title: "Error! ...",   
                    html: "Refresh the page and try again" ,   
                    type: "error",   
                    confirmButtonText: "Close",
                    focusConfirm:true 
                    }
                    ,function(isConfirm) {}
                  );
            }
        });

        return false;
    });

    $(document).on("click", "#search-backbtn" , function() {
         $("#display-show").hide();
         $("#form-wrapper").show();

         $("form.form-search").trigger("reset");

    });



 
    
 });